<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-6 border-right p-5">
                <form @submit.prevent="submitAddNewUser">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.username')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-user"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control pl-3" v-maska data-maska="z" data-maska-tokens="z:[A-Z,a-z,0-9,.]:multiple" :placeholder="$t('label.username')" v-model="username" required>
                            <div class="input-group-append">
                                <span class="input-group-text bg-transparent">@tunai</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.contact')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-phone-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation" required>
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.password')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-lock"></i>
                                </span>
                            </div>
                            <input :type="newType" class="form-control bg-transparent pl-3" :placeholder="$t('label.password')" v-model="newPassword" @keyup="passwordValidation" required>
                            <a class="show-password-icon link" @click="newType = newType == 'password' ? 'text' : 'password'">
                                <i class="fas" :class="newType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </a>
                        </div>
                        <div id="errNewPassword" class="error-validation"></div>
                    </div>
                    <div class="form-group mb-1">
                        <label class="form-label">{{$t('label.confirmed_password')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-lock"></i>
                                </span>
                            </div>
                            <input :type="confirmType" class="form-control bg-transparent pl-3"  :placeholder="$t('label.confirmed_password')" v-model="confirmPassword" @keyup="validateNewAndConfirmPassword" required>
                            <a class="show-password-icon link" @click="confirmType = confirmType == 'password' ? 'text' : 'password'">
                                <i class="fas" :class="confirmType == 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                            </a>
                        </div>
                    </div>
                    <div id="errPassword" class="error-validation"></div>
                    <div class="text-left mt-5">
                        <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnUserList">{{$t('button_link.cancel')}}</button>
                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                </form>
            </div>
            <div class="col-lg-6 col-xl-5 pl-lg-3 pb-5 d-flex align-items-center">
                <div class="help-block fs-md">
                    <p>{{$t('message.contact_validation.notes')}}:</p>
                    <ul>
                        <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                        <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {contactValidation} from './../../../../assets/js/dashboard/utilities';
import { vMaska } from "maska";
export default {
    name: 'userForm',
        directives: { maska: vMaska },
    data(){
        return{
            username: "", 
            contact: "", newPassword: "", confirmPassword: "",
            newType: "password", confirmType: "password", 
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.returnUserList()
            }
            this.$parent.$parent.isModalShow = false;
        },
        validateNewAndConfirmPassword(){
            document.getElementById('errPassword').innerHTML = this.newPassword != this.confirmPassword ? this.$i18n.t('message.error.diff_password') : null
        },
        returnUserList(){
            this.$emit('returnUserList');
        },
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        passwordValidation(){
            if(this.newPassword.length < 8){
                document.getElementById('errNewPassword').innerHTML = this.$i18n.t('message.error.min_char_password')
                this.confirmPassword = ""
            }else{
                document.getElementById('errNewPassword').innerHTML = null
            }
        },
        submitAddNewUser(){
            let $vm = this;
            if(document.getElementById('err').innerHTML != ""){
                $vm.$parent.$parent.setModal($vm, true, true, document.getElementById('err').innerHTML);
            }else if(document.getElementById('errNewPassword').innerHTML != ""){
                $vm.$parent.$parent.setModal($vm, true, true, document.getElementById('errNewPassword').innerHTML);
            }else if(document.getElementById('errPassword').innerHTML != ""){
                $vm.$parent.$parent.setModal($vm, true, true, document.getElementById('errPassword').innerHTML);
            }else{
                var data = {
                    username: this.username + "@tunai",
                    mobile: this.contact,
                    password: this.confirmPassword,
                }
                $vm.$axios({
                    method: 'post', 
                    url: $vm.$api.USER,
                    baseURL: $vm.$axios.defaults.baseURL, 
                    headers: {token: $vm.$session.get('token')},
                    data: data,
                })
                .then((response) => {
                    if(response.status == 200){
                        var message = $vm.$i18n.t(`subMenu.my_salon_user`) + $vm.$i18n.t('message.success.add')
                        $vm.$parent.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    $vm.$parent.$parent.setModal($vm, true, true,  $vm.$i18n.t('message.error.system_error'));
                })
            }
        },
    },
    
}
</script>
<style scoped>
.show-password-icon{
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 99;
}
.link{
    cursor: pointer;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>